import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import sanitizeHtml from 'sanitize-html';
import { Container, Row, SideCol } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { buildKey } from '@yme/utils/common';
import sanitizeWhiteList from '@yme/utils/sanitize-html.whitelist';
import { DATA_TABLE_TEST_ID, CELL_KEY, HEAD_CELL_KEY, ROW_KEY } from './constants';
import { getTableCells, getParsedData } from './helpers';
import { DataTableStyled, DataTableWrapper, TableCellHeadStyled, TableCellStyled, TableRowStyled, } from './styled';
export function DataTable({ tableData, isRemoveBottomIndent, isUnfreezeFirstColumn, }) {
    const [hasScroll, setHasScroll] = useState(false);
    const isRightToLeft = useSelector(getRTL);
    const tableWrapperRef = useRef(null);
    const parsedData = useMemo(() => getParsedData(tableData), [tableData]);
    useEffect(() => {
        const scrollCondition = tableWrapperRef.current &&
            tableWrapperRef.current?.scrollWidth > tableWrapperRef.current?.clientWidth;
        if (scrollCondition) {
            setHasScroll(true);
        }
        else {
            setHasScroll(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableWrapperRef?.current]);
    const { bodyCellsData, headCellsData, isEmptyHeaderRow, isEmptyTable } = getTableCells(parsedData);
    const countCells = headCellsData?.length ?? 0;
    const headData = headCellsData?.map((item, index) => (React.createElement(TableCellHeadStyled, { isFirst: index === 0, customStyles: item.style, hasScroll: hasScroll, isUnfreezeFirstColumn: isUnfreezeFirstColumn, isRightToLeft: isRightToLeft, countCells: countCells, colSpan: item.colSpan, rowSpan: item.rowSpan, key: buildKey(HEAD_CELL_KEY, index), dangerouslySetInnerHTML: {
            __html: sanitizeHtml(item.value, sanitizeWhiteList),
        } })));
    const bodyData = bodyCellsData?.map((row, rowIndex) => {
        const cell = row.map((item, cellIndex) => (React.createElement(TableCellStyled, { isFirst: cellIndex === 0, customStyles: item.style, colSpan: item.colSpan, rowSpan: item.rowSpan, isOdd: Boolean((rowIndex + 1) % 2), hasScroll: hasScroll, isUnfreezeFirstColumn: isUnfreezeFirstColumn, isRightToLeft: isRightToLeft, countCells: countCells, key: buildKey(CELL_KEY, cellIndex), dangerouslySetInnerHTML: {
                __html: sanitizeHtml(item.value, sanitizeWhiteList),
            } })));
        return React.createElement(TableRowStyled, { key: buildKey(ROW_KEY, rowIndex) }, cell);
    });
    if (!tableData || (isEmptyHeaderRow && isEmptyTable) || (!isEmptyHeaderRow && isEmptyTable)) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { dataTestId: DATA_TABLE_TEST_ID },
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(SideCol, { isLeftAlign: isRightToLeft, lg: 8, md: 8, sm: 4, smFixed: true, mdFixed: true, lgFixed: false },
                    React.createElement(DataTableWrapper, { ref: tableWrapperRef, isRightToLeft: isRightToLeft, isHorizontal: true },
                        React.createElement(DataTableStyled, null,
                            !isEmptyHeaderRow && (React.createElement("thead", null,
                                React.createElement(TableRowStyled, { isHead: true }, headData))),
                            React.createElement("tbody", null, bodyData))))))));
}
DataTable.displayName = 'DataTable_AEMComponent';
